import { When } from 'react-if';

import { Button, Row, Space } from 'antd';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const titleMap = {
	[ FULL_ROUTES.ISSUES ]: COPY_SPECIFIC.VALIDATION_RULE_ISSUES,
	[ FULL_ROUTES.ISSUES_ARCHIVED ]: COPY_SPECIFIC.ARCHIVED_ISSUES,
	[ FULL_ROUTES.ISSUES_SNOOZED ]: COPY_SPECIFIC.SNOOZED_ISSUES
};

export const PotentialIssuesHeader: React.FC = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const onIssues = location.pathname === FULL_ROUTES.ISSUES;
	const onArchived = location.pathname === FULL_ROUTES.ISSUES_ARCHIVED;
	const onSnoozed = location.pathname === FULL_ROUTES.ISSUES_SNOOZED;

	const handleClick = useCallback(
		(e: React.MouseEvent<HTMLElement>) => {
			const target = e.target as HTMLElement;
			const parentButton = target.parentElement as HTMLButtonElement;

			if (parentButton && parentButton.value) {
				navigate(parentButton.value);
			}
		},
		[ navigate ]
	);

	return (
		<Row
			align='middle'
			className='h1'
			justify='space-between'>
			{ titleMap[ location.pathname ] }
			<Space size='small'>
				<When condition={ onIssues || onArchived }>
					<Button
						id='view-snoozed-issues'
						onClick={ handleClick }
						type='link'
						value={ FULL_ROUTES.ISSUES_SNOOZED }>
						{ COPY_SPECIFIC.VIEW_SNOOZED }
					</Button>
				</When>
				<When condition={ onIssues || onSnoozed }>
					<Button
						id='view-archived-issues'
						onClick={ handleClick }
						type='link'
						value={ FULL_ROUTES.ISSUES_ARCHIVED }>
						{ COPY_SPECIFIC.VIEW_ARCHIVED }
					</Button>
				</When>
				<When condition={ onArchived || onSnoozed }>
					<Button
						id='view-potential-issues'
						onClick={ handleClick }
						type='link'
						value={ FULL_ROUTES.ISSUES }>
						{ COPY_SPECIFIC.VIEW_POTENTIAL_ISSUES }
					</Button>
				</When>
			</Space>
		</Row>
	);
};
